'use strict'

SearchBarView = require './views/desktop_search'
Location = require '../../../../../src/frontend/helper/search/helper/m_location_helper'
ClosestDivision = require '../../../../../src/frontend/helper/search/common/m_closest_division'
{setTranslations} = require '../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee'
Geocoder = require '../../../../../src/frontend/helper/search/common/m_geocoder'

# Groupon.Modules.SearchBar:
module.exports = SearchBar = {
  Autocomplete: {}

  init: (options) ->
    SearchBar.GOOGLE_GEO_URL = options.google_geo_url
    Location.setDivision(options.division)
    setTranslations(Groupon.LS.translations)

    if $('form#ls-search-form').length
      new SearchBarView()
}

$ ->
  if (searchConfig = Groupon.Modules.SearchBar.Config)
    Groupon.Modules.SearchBar.init(searchConfig)

window.Groupon.Utils ?= {}
Object.assign Groupon.Utils, {
  ClosestDivision
  Geocoder
}

window.Groupon.Modules ?= {}
window.Groupon.Modules.SearchBar ?= {}
Object.assign window.Groupon.Modules.SearchBar, SearchBar



// WEBPACK FOOTER //
// ./modules/gig_body/header/search_bar/frontend/desktop_searchbar.coffee